import { render } from "./App.vue?vue&type=template&id=79884b5a"
const script = {}

import "./App.vue?vue&type=style&index=0&id=79884b5a&lang=scss"

import exportComponent from "F:\\嘉石BBS\\dd-jsbss\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__